import {createFileRoute} from '@tanstack/react-router';

import ImagePage from '~components/common/ImagePage';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/model/finetune/image')({
  component: ModelFinetuneImagePage,
});

function ModelFinetuneImagePage(): JSX.Element {
  return (
    <ModelProvider mode='archive-annotator'>
      <ImagePage />
    </ModelProvider>
  );
}
